export const truncateString = (str, maxLength = 14) => {
  if (!str) return '';
  return str.length > maxLength ? `${str.substring(0, maxLength)}...` : str;
};

// "I".toLocaleLowerCase('tr') === 'ı' (dotless), so acronyms like FIFA/NBA never
// match a plain-typed "fifa"/"nba" query. Fold all I/İ/ı variants to a single
// 'i' before lowercasing so search is agnostic to which "i" was typed.
export const foldTurkishI = text => (text || '').replace(/[İIı]/g, 'i');
